import { Directive, OnDestroy, OnInit } from '@angular/core';
import { LayoutService } from '@fgb/portal-component-library/src/lib/shared/services';

/**
 * Reusable directive to hide mobile navigation when added to a component. Add it to the hostDirectives array of a component 
 * to hide the mobile navigation when the component is loaded and restore the default navigation settings when the component is destroyed.
 *
 * @deprecated Declare it on the route instead, with `layoutConfig({ mobileNavbar: false })` in the
 * route's `data`. The route declaration covers every element of the shell in one place, cascades to
 * child routes, and is restored by the master page on the next navigation rather than depending on
 * the component being destroyed. This directive still works and is kept for existing usages.
 * @example
 * {
 *   path: 'auction/:id',
 *   component: AuctionDetailPageComponent,
 *   data: layoutConfig({ mobileNavbar: false }),
 * }
 */
@Directive({
  selector: '[hideMobileNav]',
  standalone: true
})
export class HideMobileNav implements OnInit, OnDestroy{

  constructor(private layoutService: LayoutService) {}

   ngOnInit(): void {
    setTimeout(() => {
      // Hide mobile navigation upon component initialization
      this.layoutService.hideMobileNavbar();
    });
   }

   ngOnDestroy(): void {
     // Show mobile navigation upon component destruction
     this.layoutService.showMobileNavbar();
   }

}
